import type { SVGProps } from "react";

export function IconBlueStorefrontAlt(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_13814_13623)">
        <rect opacity="0.5" width="56" height="56" fill="#E4E7FC" />
        <path
          d="M28 40V34M16 16H40V40H16V16Z"
          stroke="#0B0C17"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.75 15.25H15.25V26.9295L15.4377 27.1421C16.307 28.127 17.5812 28.75 19 28.75C21.09 28.75 22.8648 27.4002 23.5 25.5247C24.1352 27.4002 25.91 28.75 28 28.75C30.09 28.75 31.8648 27.4002 32.5 25.5247C33.1352 27.4002 34.91 28.75 37 28.75C38.4188 28.75 39.693 28.127 40.5623 27.1421L40.75 26.9295V15.25Z"
          fill="#5486FA"
        />
        <path
          d="M16 20.5L40 20.5"
          stroke="#0B0D17"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_13814_13623">
          <rect width="56" height="56" rx="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
